export function Spinner() {
  return (
    <div className="flex min-h-full items-center justify-center">
      <div className="size-8 animate-spin rounded-full border-4 border-slate-200 border-t-primary-600" />
    </div>
  );
}
